import { Zip } from '../models/zip';
import { stateMapper } from './state.mapper';

/**
 * Map from dto.
 * @param {object} dto Dto.
 * @returns {Zip}
 */
function fromDto(dto) {
  return new Zip({
    areaCode: dto.area_code,
    city: dto.city,
    county: dto.county,
    countyFip: dto.county_fip,
    daylightSavings: dto.daylight_savings,
    elevation: dto.elevation,
    id: dto.id,
    latitude: dto.latitude,
    longitude: dto.longitude,
    state: stateMapper.fromDto(dto.state),
    stateCode: dto.state_code,
    timezone: dto.timezone,
    zip: dto.zip,
  });
}

export const zipMapper = {
  fromDto,
};
